const config = {
  elasticURL: process.env.REACT_APP_ELASTIC_URL,
};

export default config;
